/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import {format, sub }from "date-fns";

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Typography, Paper, Avatar, Tooltip, IconButton } from '@material-ui/core';
import { FilterList } from '@material-ui/icons'

import MultiPicker from './MultiPicker';


const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class RangeSelector extends Component {
    state = {
        start_date: null,
        end_date: null,
        resolution : null,
        picker_open : false,
        anchrEl : null,
        container_width : null
    }

    filter = React.createRef()

    componentDidMount () {
        let container_width = this.filter.current.clientWidth
        this.setState({
            ...this.state,
            container_width : container_width,
            start_date : format(sub(new Date(), {
                years: 0,
                months: 1,
                weeks: 0,
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }), "yyyy-MM-dd'T'HH:mm:ssxxx"), 
            end_date : format(new Date(), "yyyy-MM-dd'T'HH:mm:ssxxx"),
            resolution : "Daily"
        }, () => {
            this.props.onClose(
                {
                    start_date : this.state.start_date,
                    end_date : this.state.end_date,
                    resolution : this.state.resolution
                }
            )
        })
    }

    openPicker = (event) => {
        this.setState({...this.state, picker_open : true, anchorEl : event.currentTarget})
    }

    closePicker = (event) => {
        this.setState({...this.state, picker_open : false, anchorEl : event.currentTarget}, () => {
            this.props.onClose(
                {
                    start_date : this.state.start_date,
                    end_date : this.state.end_date,
                    resolution : this.state.resolution
                }
            )
        })
    }

    updateFilter = (key, value) => {
        this.setState({
            ...this.state,
            [key] : value
        })
    }

    getFormattedDate = (date_string) => {
        if (date_string !== null) {
            console.log("Formatting Date: ", date_string)
            return format(new Date(date_string), "do MMM yyyy")
        } else {
            return null
        }
    }

    renderFilterText = () => {
        return(
            <Paper 
                ref = {this.filter} 
                elevation = {0} 
                square 
                style = {{width : '100%', display : 'inline-flex',flexDirection : 'row', alignItems : 'center', cursor : 'pointer'}} 
                onClick = {(event) => this.openPicker(event)}
            >
                <div style = {{padding : '10px'}}>
                    <Typography color = 'textSecondary' variant = 'body2'><em>Showing </em><Typography variant = 'subtitle2' color = 'primary' display = 'inline'>{this.state.resolution}</Typography><em> results starting from </em><Typography variant = 'subtitle2' color = 'primary' display = 'inline'>{this.getFormattedDate(this.state.start_date)}</Typography><em> to </em><Typography variant = 'subtitle2' color = 'primary' display = 'inline'>{this.getFormattedDate(this.state.end_date)}</Typography><Typography style = {{marginLeft : '10px'}} display = 'inline' variant = 'caption' color = 'primary'><em>(click to edit)</em></Typography></Typography>
                </div>
                <div style = {{padding : '5px', borderRight : '1px solid #FFFFFF', backgroundColor : "#2296f3"}}>
                    <Tooltip title = "Filter">
                        <IconButton size = 'small'>
                            <FilterList style = {{color : "#FFFFFF"}}/>
                        </IconButton>
                    </Tooltip>
                </div>
            </Paper>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div>
                    {this.renderFilterText()}
                    <MultiPicker 
                        open = {this.state.picker_open} 
                        anchorEl = {this.state.anchorEl} 
                        width = {this.state.container_width} 
                        handleClose = {(event) => {
                            this.closePicker(event)
                        }}
                        update_filter = {(filter, value) => this.updateFilter(filter, value)}
                        filter = {{
                            resolution : this.state.resolution,
                            start_date : this.state.start_date,
                            end_date : this.state.end_date
                        }}
                    />
                </div>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(RangeSelector);